import {
  ButtonCoreDriver,
  buttonCoreDriverFactory,
} from '../Button/ButtonCore/ButtonCore.uni.driver';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import type {
  BaseUniDriver,
  UniDriver,
} from '@wix/wix-ui-test-utils/unidriver';

export const closeButtonDriverFactory = (base: UniDriver) => {
  const buttonDriver = buttonCoreDriverFactory(base);

  return {
    ...baseUniDriverFactory(base),
    /** Checks whether the button is disabled
     * @returns {Promise<boolean>}
     * */
    isButtonDisabled: buttonDriver.isButtonDisabled,
    /** Returns the aria-label attribute of the button
     * @returns {Promise<string | null>}
     * */
    getAriaLabel: async () => base.attr('aria-label'),
  };
};

export interface CloseButtonUniDriver extends BaseUniDriver {
  isButtonDisabled: ButtonCoreDriver['isButtonDisabled'];
  getAriaLabel: () => Promise<string | null>;
}
